import * as types from "./intlActionTypes";

export function setLocale(locale) {
  return {
    type: types.SET_LOCALE,
    locale,
  };
}



// WEBPACK FOOTER //
// ./src/components/intl/intlActions.js